import React from 'react';

function UserFeedback() {
  const testimonials = [
    {
      id: 1,
      name: "Krushna Agarwal",
      role: "Business Owner",
      feedback: "Siddhant Exim Academy has been a game-changer for my import-export business. The comprehensive courses cover everything from international trade regulations to practical strategies for finding and managing overseas clients. The instructors are highly recommended for anyone looking to scale their import-export operations.",
      rating: 5,
      image: "/User.png"
    },
    {
      id: 2,
      name: "Rajesh Sharma",
      role: "Export Manager",
      feedback: "I had an excellent experience with Siddhant Exim Academy. The curriculum is well-structured and easy to follow, even for beginners. The support from the program helped me feel much more confident in managing international transactions, understanding customs regulations, and building relationships with global suppliers.",
      rating: 5,
      image: "/User.png"
    },
  ];

  const StarRating = ({ rating }: { rating: number }) => {
    return (
      <div className="flex space-x-1 mb-4">
        {[...Array(5)].map((_, index) => (
          <span 
            key={index}
            className={`text-lg ${
              index < rating ? 'text-amber-500' : 'text-gray-300'
            }`}
          >
            ★
          </span>
        ))}
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-white to-gray-50/50 py-16">
      <div className="container mx-auto px-4">
        
        {/* Heading Section */}
        <div className="text-center mb-16 animate-fade-in">
          <div className="inline-block mb-4">
            <div className="w-20 h-1 bg-amber-400 rounded-full mb-2"></div>
            <div className="w-16 h-1 bg-amber-300 rounded-full"></div>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            What Our <span className="text-amber-500">Users Say</span>
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Discover how Siddhant Exim Academy has transformed careers and businesses worldwide
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-7xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <div 
              key={testimonial.id}
              className="group animate-slide-up"
              style={{ animationDelay: `${index * 200}ms` }}
            >
              <div className="bg-white rounded-2xl p-8 border border-gray-100 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 relative overflow-hidden">
                
                {/* Background Pattern */}
                <div className="absolute top-0 right-0 w-24 h-24 bg-amber-50 rounded-full -translate-y-12 translate-x-12 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                
                {/* User Image */}
                <div className="flex items-start space-x-4 mb-6">
                  <div className="flex-shrink-0">
                    <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-amber-200 shadow-md group-hover:border-amber-400 transition-all duration-300">
                      <img 
                        src={testimonial.image} 
                        alt={testimonial.name}
                        className="w-full h-full object-cover"
                        onError={(e) => {
                          // Fallback if image doesn't load
                          e.currentTarget.src = "/User.png";
                        }}
                      />
                    </div>
                  </div>
                  <div className="flex-1">
                    {/* Star Rating */}
                    <StarRating rating={testimonial.rating} />
                    
                    {/* Name and Role */}
                    <div className="mb-2">
                      <p className="text-gray-900 font-bold text-xl">{testimonial.name}</p>
                      <p className="text-amber-600 font-semibold text-sm">{testimonial.role}</p>
                    </div>
                  </div>
                </div>

                {/* Feedback Text */}
                <div className="text-gray-700 leading-relaxed text-lg mb-6 relative z-10 pl-20">
                  <span className="text-3xl text-amber-400 absolute -left-2 -top-2 opacity-20">"</span>
                  {testimonial.feedback}
                  <span className="text-3xl text-amber-400 absolute -right-2 -bottom-2 opacity-20">"</span>
                </div>

                {/* Verified Badge */}
               

                {/* Hover Border Effect */}
                <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-amber-400 to-amber-600 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500"></div>
              </div>
            </div>
          ))}
        </div>

      </div>

      {/* Add CSS Animations */}
      <style>{`
        @keyframes fade-in {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        
        @keyframes slide-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-fade-in {
          animation: fade-in 1s ease-out forwards;
        }
        
        .animate-slide-up {
          animation: slide-up 0.8s ease-out forwards;
          opacity: 0;
        }
        
        .delay-300 {
          animation-delay: 300ms;
        }
      `}</style>
    </div>
  );
}

export default UserFeedback;